import { render, staticRenderFns } from "./SaveModal.vue?vue&type=template&id=54845ab5&"
import script from "./SaveModal.vue?vue&type=script&lang=js&"
export * from "./SaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports